// extracted by mini-css-extract-plugin
export var messageSideLeft = "_i1-1";
export var messageSideRight = "_i1-2";
export var subscribeToBackInStockBubbleContainer = "_i1-0";